import styled from 'styled-components';
import { FlexColumn, FlexRow } from '@make-software/tg-mini-app-ui';

export const Root = styled(FlexColumn)`
  min-height: 100vh;
  width: 90%;
  padding: 18px 16px;
  background: ${({ theme }) => theme.colors.darkCard};
  align-items: center;
  justify-content: center;
`;

export const Card = styled(FlexColumn)`
  width: 90%;
  max-width: 420px;
  background: ${({ theme }) => theme.colors.modalBg};
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 16px;
  gap: 14px;
`;

export const Header = styled(FlexColumn)`
  gap: 6px;
`;
export const Title = styled.div`
  font-size: 18px;
  font-weight: 900;
  color: ${({ theme }) => theme.colors.contentPrimary};
`;
export const Subtitle = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.contentMuted};
  line-height: 1.35;
  b {
    color: ${({ theme }) => theme.colors.contentPrimary};
    font-weight: 900;
  }
`;

export const Box = styled(FlexColumn)`
  gap: 8px;
  padding: 12px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: 900;
  color: ${({ theme }) => theme.colors.contentPrimary};
`;

export const Input = styled.input`
  height: 48px;
  border-radius: 12px;
  padding: 0 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: ${({ theme }) => theme.colors.contentPrimary};
  font-weight: 900;
  font-size: 22px;
  letter-spacing: 6px;
  outline: none;
`;

export const MetaRow = styled(FlexRow)`
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

export const Small = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.contentMuted};
  font-weight: 700;
`;
export const Pill = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.contentPrimary};
  font-weight: 900;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ErrorText = styled.div`
  font-size: 12px;
  color: #ffb4b4;
  font-weight: 800;
`;
export const Buttons = styled(FlexRow)`
  gap: 10px;
  align-items: center;
  justify-content: space-between;
`;
export const Footer = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.contentMuted};
  line-height: 1.35;
`;
